import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import VueHead from "vue-head";
import { createPinia } from 'pinia';
import { markRaw } from 'vue'

import "./assets/styles/index.scss";
import ClickOutside from "./directives/ClickOutside";
import FormErrors from "./directives/FormErrors";
import VueDOMPurifyHTML from "vue-dompurify-html";
import { image } from "./common/mixins/image";
import Breadcrumbs from './common/components/Breadcrumbs.vue';

const pinia = createPinia();
pinia.use(({store}) => {
    store.router = markRaw(router);
})

const app = createApp(App)
    .use(router)
    .use(i18n, {
        legacy: true
    })
    .use(pinia)
    .use(VueHead)
    .use(VueDOMPurifyHTML, {
        namedConfigurations: {
            hmwk_desc: {
                ALLOWED_TAGS: ["b", "a", "ul", "ol", "li", "br"],
                ALLOWED_ATTR: ["target", "class", "href", "data-testid"]
            }
        }
    });

app.directive("click-outside", ClickOutside);
app.directive("form-errors", FormErrors);
app.mixin(image);
app.component("breadcrumbs", Breadcrumbs);

app.mount("#app");
